@use "variables" as *;

.item {
  border-radius: 12px;
}

.container {
  width: 100%;
  display: flex;
}

.actionArea {
  display: flex;
  flex-grow: 1;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
}

.readName {
  font-size: $fontSize-m;
  font-weight: normal;
  text-align: left;
  width: 100%;
}

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
}

.severityMark {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 12px;
}

.discountBox {
  margin-left: $spacing-s;
}

.price {
  text-align: right;
  margin-left: $spacing-s;
  white-space: nowrap;
}

.oldPrice {
  text-align: center;
  font-size: $fontSize-xxs;
  text-decoration-line: line-through;
  font-weight: lighter;
}

.newPrice {
  font-size: $fontSize-s;
  font-weight: bold;
}
